import axios from "axios";
export const SEEDGREEN_BASE_URL = 
// Absolute URL needed for MSW in tests (Node environment has no window.location to resolve relative URLs against)
process.env.NODE_ENV === "test" ? "http://localhost" : ""; // Use relative paths in dev/prod - Vite/Vercel proxy handles routing
/**
 * Seedgreen API with Cookie-based authentication
 */
export const seedgreenAPI = axios.create({
    baseURL: SEEDGREEN_BASE_URL + "/API/",
    withCredentials: true,
});
